import React from 'react';
import './DeleteTaskForm.scss';
import { closeDeleteQuizTaskForm, deleteQuizTask } from '../../../MainVIew/Tasks/taskSlice';


const DeleteQuizTaskForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete quiz task action');

        const data = {
            taskId: props.taskId,
            quizId: props.quizId
            
        }

       dispatch(deleteQuizTask(data));
       console.log(data);
    
       dispatch(closeDeleteQuizTaskForm());
      // props.onClickClear();
    }
    

    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteQuizTaskForm());
    

    }


    const render = () => {

        
            return(
                <div className="DeleteTaskForm">
                    
                <p><b>Вы действительно хотите удалить Заметку?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       
   
    }
return render();
}
export default DeleteQuizTaskForm;
  